import { Fragment, useEffect, useRef, useState } from "react";
import {
    Card,
    Col,
    Container,
    Input,
    Label,
    Row
} from "reactstrap";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { ensureDexieReady, getFieldValuesFromDexie, getFilteredPositionIds } from "../../db/DexieServises";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import { ReportDARTitle, ReportListTitle, ReportTitle } from "../../Utils/Constants";
import MonthDropdown from "../CommonCompo/MonthDropdown";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import CommonTable from "../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import DatePicker from 'react-datepicker'
import { useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import CommonTableNew from "../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import { Calendar } from 'react-feather';
import 'react-datepicker/dist/react-datepicker.css';
import { getLabel } from "../../sharedFunctions/CommonLable";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Utils";
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-toolkit/store';

interface DARReportProps {
    positionId: string;
    startDate: string;
}

export default function DARReports() {
    //    const { positionId } = useParams(); // from route
    //     const location = useLocation();
    // const selectedMonths = startDate; // from state

    // console.log("positionId:", positionId);
    // console.log("startDate:", startDate);
    const [searchText, setSearchText] = useState('');
    const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
    const [effortData, setEffortData] = useState<any[]>([]);
    const [displayedData, setDisplayedData] = useState<any[]>(effortData);
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const [selectedMonth, setSelectedMonth] = useState<string>('');
    const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [loading, setLoading] = useState(true);
    const unitId = useSelector((state: RootState) => state.orgUnit.id);

    const handleChange = (date: Date | null) => {
        setStartDate(date);
    };
    const datePickerRef = useRef<any>(null);

    const handleContainerClick = () => {
        if (datePickerRef.current) {
            datePickerRef.current.setFocus(); // Opens calendar
        }
    };
    useEffect(() => {
        if (startDate && unitId) {
            handleSubmitAPI();
        }
    }, [startDate, selectedIds, unitId]); // Added unitId to dependencies
    const handleSubmitAPI = async () => {
        setLoading(true); // 👈 Stop loader

        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }
        await ensureDexieReady();

        const ids = await getFilteredPositionIds('Position', unitId);
        // console.log(ids, 'pos idsssssss');
        const positionIds = selectedIds.length > 0 ? selectedIds : (ids ? ids : []);
        const month = startDate?.toISOString().split('T')[0] || '';
        // console.log("📦 API Call Payload:", {
        //     position_id: positionIds,
        //     date: month
        // });

        const url = `${serverUrl}${API.getDarReport}`;
        const { status, data } = await getData(url, true, {
            position_id: positionIds,
            date: month,
        });

        if (status === 200 && Array.isArray(data?.data)) {
            // console.log("📦 Raw API Data:getDarReport", data?.data); // <-- add this
            // console.log("📦 Raw API Data:getDarReport", status); // <-- add this
            setEffortData(data?.data);
            setLoading(false); // 👈 Stop loader

        } else {
            setEffortData([]); // fallback
        }
        setLoading(false); // 👈 Stop loader
    };

    useEffect(() => {
        const lower = searchText.toLowerCase();

        const filtered = effortData.filter((item) => {
            // ✅ Only filter by search text (not by selectedIds)
            return item?.FirstName?.toLowerCase().includes(lower) || item?.OutletName?.toLowerCase().includes(lower) || item?.EmployeeCode?.toLowerCase().includes(lower) || item?.PositionName?.toLowerCase().includes(lower) || item?.Stownname?.toLowerCase().includes(lower) || item?.SgpiOut?.toLowerCase().includes(lower) || item?.ManagersName?.toLowerCase().includes(lower)
        });
        setDisplayedData(filtered);
        // console.log("📊 Filtered Data:", filtered);
    }, [searchText, effortData]); // ✅ remove selectedIds from dependency
    const keys = displayedData.length > 0 ? Object.keys(displayedData[0]) : [];

    const headData = keys.map((key, index) => ({
        id: index,
        head: key,
    }));
    // console.log("Selected Key", selectedKey);
    // console.log("Displayed Data", displayedData);

    // const captionTableHeader = [
    //     { id: 1, head: "Agenda Type" },
    //     { id: 2, head: "Employee Code" },
    //     { id: 3, head: "First Name" },
    //     { id: 4, head: "Outlet Name" },
    //     { id: 5, head: "Outlet Code" },
    //     { id: 6, head: "Agenda Name" },
    //     { id: 7, head: "Position Name" },
    //     { id: 8, head: "Start Town" },
    //     { id: 9, head: "Date" },
    //     { id: 10, head: "Status" },
    //     { id: 11, head: "Planned" },
    //     { id: 12, head: "Unit Name" },
    //     { id: 13, head: "Sgpi Out" },
    //     { id: 14, head: "Pob Total" },
    //     { id: 15, head: "Ed Duration" },
    //     { id: 16, head: "Outlet Type Name" },
    //     { id: 17, head: "Beat Name" },
    //     { id: 18, head: "Tags" },
    //     { id: 19, head: "Joint Working" },
    //     { id: 20, head: "Campaign Name" },
    //     { id: 21, head: "Managers Name" },


    // ]

    const captionTableHeader = [
        { id: '1', head: 'Agenda Type', key: 'Agendacontroltype', sortKey: 'Agendacontroltype' },
        { id: '2', head: 'Employee Code', key: 'EmployeeCode', sortKey: 'EmployeeCode' },
        { id: '3', head: 'Name', key: 'FirstName', sortKey: 'FirstName' },
        { id: '4', head: `${getLabel("Outlet")} Name`, key: 'OutletName', sortKey: 'OutletName' },
        { id: '5', head: getLabel("OutletOrgCode"), key: 'OutletCode', sortKey: 'OutletCode' },
        { id: '6', head: 'Agenda Name', key: 'Agendname', sortKey: 'Agendname' },
        { id: '7', head: 'Position Name', key: 'PositionName', sortKey: 'PositionName' },
        { id: '8', head: 'Start Town', key: 'Stownname', sortKey: 'Stownname' },
        { id: '9', head: 'Date', key: 'DcrDate', sortKey: 'DcrDate' },
        { id: '10', head: 'Status', key: 'DcrStatus', sortKey: 'DcrStatus' },
        { id: '11', head: 'Planned', key: 'Planned', sortKey: 'Planned' },
        { id: '12', head: 'Unit Name', key: 'UnitName', sortKey: 'UnitName' },
        { id: '13', head: `${getLabel("Input")} Out`, key: 'SgpiOut', sortKey: 'SgpiOut' },
        { id: '14', head: `${getLabel("POB")} Total`, key: 'PobTotal', sortKey: 'PobTotal' },
        { id: '15', head: 'Ed Duration', key: 'EdDuration', sortKey: 'EdDuration' },
        { id: '16', head: `${getLabel("Outlet")} Type Name`, key: 'OutlettypeName', sortKey: 'OutlettypeName' },
        { id: '17', head: 'Beat Name', key: 'BeatName', sortKey: 'BeatName' },
        { id: '18', head: 'Tags', key: 'Tags', sortKey: 'Tags' },
        { id: '19', head: 'Joint Working', key: 'Isjw', sortKey: 'Isjw' },
        { id: '20', head: 'Campaign Name', key: 'BrandCampaignName', sortKey: 'BrandCampaignName' },
        { id: '21', head: "Manager's Name", key: 'ManagersName', sortKey: 'ManagersName' },
        { id: '22', head: "Submission date ", key: 'Submission date ', sortKey: 'Submission date' }
    ];

    const handleExportToExcel = () => {
        const exportData = displayedData.map(row => ({
            "Agenda Type": row.Agendacontroltype,
            "Employee Code": row.EmployeeCode,
            "Name": row.FirstName,
            "Outlet Name": row.OutletName,
            "Outlet Code": row.OutletCode,
            "Agenda Name": row.Agendname,
            "Position Name": row.PositionName,
            "Start Town": row.Stownname,
            "Date": row.DcrDate,
            "Status": row.DcrStatus,
            "Planned": row.Planned,
            "Unit Name": row.UnitName,
            "Sgpi Out": row.SgpiOut,
            "Pob Total": row.PobTotal,
            "Ed Duration": row.EdDuration,
            "Outlet Type Name": row.OutlettypeName,
            "Beat Name": row.BeatName,
            "Tags": row.Tags,
            "Joint Working": row.Isjw,
            "Campaign Name": row.BrandCampaignName,
            "Manager's Name": row.ManagersName,
            "Submission date ": row.UpdatedAt,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "DAR Report");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Daily_Activity_Report_${startDate}.xlsx`);
    };

    return (
        <div className='page-body p-2'>
            <Card>
                <div className='d-flex justify-content-between align-items-center pt-2 pb-2'>
                    <CardHeaderSpan headingClassName='pb-0' back={true} heading={ReportDARTitle} span={ReportListTitle} />
                    {/* <div className='p-3'>
                        <DatePicker className="form-control flatpickr-input" selected={startDate} maxDate={new Date()} // ✅ Disables future dates
                            onChange={handleChange} dateFormat="MMMM dd,yyyy" />
                    </div> */}
                    <div className="p-3">
                        <div
                            onClick={handleContainerClick}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                width: '180px',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '4px 10px',
                                marginRight: "30px"
                            }}
                            className="bg-primary"
                        >
                            <Calendar size={20} color="#fff" />
                            <DatePicker
                                selected={startDate}
                                onChange={handleChange}
                                maxDate={new Date()}
                                dateFormat="MMMM dd, yyyy"
                                className="form-control border-0 p-0 text-light"
                                wrapperClassName="w-100"
                                ref={datePickerRef}
                                onCalendarClose={() => datePickerRef.current?.setBlur()} // Ensure proper close behavior
                            />
                        </div>
                    </div>
                </div>
                <Fragment>
                    <Container fluid>
                        <div className="row  mb-3 align-items-center justify-content-between">
                            <div className="col-md-8 d-flex align-items-center gap-3 flex-wrap">
                                <Input
                                    type="text"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search by name or position"
                                    className="form-control"
                                    style={{ maxWidth: "250px" }}
                                />
                                <TreeModel onSelectionChange={setSelectedIds} />
                            </div>

                            {/* Right side: Download Button */}
                            <div className="col-md-4 d-flex justify-content-end gap-3">

                                <button
                                    className="btn btn-sm btn-primary align-items-center d-flex "
                                    onClick={handleExportToExcel}
                                >
                                    <FeatherIconCom
                                        iconName={"Download"}
                                        size={14}
                                        className="text-light"
                                    />
                                    <span className="px-2" style={{ fontSize: 14 }}>
                                        Export
                                    </span>
                                </button>

                            </div>
                        </div>

                        <Row>
                            <Col sm={12}>
                                <div className="table-responsive">
                                    {/* <CommonTable caption="" headData={captionTableHeader}>
                                        {displayedData.length === 0 ? (
                                            <tr>
                                                <td colSpan={captionTableHeader.length} className="text-center">
                                                    No data found.
                                                </td>
                                            </tr>
                                        ) : (
                                            displayedData.map((row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    <td >{row.Agendacontroltype} </td>
                                                    <td >{row.EmployeeCode} </td>
                                                    <td >{row.FirstName} </td>
                                                    <td >{row.OutletName} </td>
                                                    <td >{row.OutletCode} </td>
                                                    <td >{row.Agendname} </td>
                                                    <td >{row.PositionName} </td>
                                                    <td >{row.Stownname} </td>
                                                    <td >{row.DcrDate} </td>
                                                    <td >{row.DcrStatus} </td>
                                                    <td >{row.Planned} </td>
                                                    <td >{row.UnitName} </td>
                                                    <td >{row.SgpiOut} </td>
                                                    <td >{row.PobTotal} </td>
                                                    <td >{row.EdDuration} </td>
                                                    <td >{row.OutlettypeName} </td>
                                                    <td >{row.BeatName} </td>
                                                    <td >{row.Tags} </td>
                                                    <td >{row.Isjw} </td>
                                                    <td >{row.BrandCampaignName} </td>
                                                    <td >{row.ManagersName} </td>

                                                </tr>
                                            ))
                                        )}
                                    </CommonTable> */}
                                    {loading ? (
                                        <div className="text-center py-3">
                                            {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
                                            <div>
                                                <Image
                                                    className="b-r-10 img-80"
                                                    src={dynamicImage('dashboard/loader.gif')}
                                                    alt="Loading..."
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <CommonTableNew
                                            caption=""
                                            headData={captionTableHeader}
                                            data={displayedData}
                                            renderRow={(row, rowIndex) => (
                                                <tr key={rowIndex}>
                                                    <td >{row.Agendacontroltype} </td>
                                                    <td >{row.EmployeeCode} </td>
                                                    <td >{row.FirstName} </td>
                                                    <td >{row.OutletName} </td>
                                                    <td >{row.OutletCode} </td>
                                                    <td >{row.Agendname} </td>
                                                    <td >{row.PositionName} </td>
                                                    <td >{row.Stownname} </td>
                                                    <td >{row.DcrDate} </td>
                                                    <td >{row.DcrStatus} </td>
                                                    <td >{row.Planned} </td>
                                                    <td >{row.UnitName} </td>
                                                    <td >{row.SgpiOut} </td>
                                                    <td >{row.PobTotal} </td>
                                                    <td >{row.EdDuration} </td>
                                                    <td >{row.OutlettypeName} </td>
                                                    <td >{row.BeatName} </td>
                                                    <td >{row.Tags} </td>
                                                    {/* <td >{row.Isjw} </td> */}
                                                    <td>{row.Isjw ? "Yes" : "No"}</td>

                                                    <td >{row.BrandCampaignName} </td>
                                                    <td >{row.ManagersName} </td>
                                                    <td >{row.UpdatedAt} </td>
                                                </tr>
                                            )}
                                        />)}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Fragment>
            </Card>
        </div>
    );
}
